import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-504d513a")

_pushScopeId("data-v-504d513a")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = {
  key: 0,
  class: "media"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "store img upload-demo media__body" }, " 上传 ", -1)
const _hoisted_4 = {
  key: 1,
  class: "el-icon-plus store-uploader-icon"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "c-90" }, " 只能上传 jpg/png 文件，且不超过 500kb ", -1)
const _hoisted_6 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center","padding":"20px 0"}
}
const _hoisted_7 = { class: "c-ff" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.form,
        "label-width": "150px"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "师傅名称",
            prop: "name"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                style: {"width":"350px"},
                modelValue: _ctx.form.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "标签",
            prop: "label"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                style: {"width":"350px"},
                modelValue: _ctx.form.label,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.label = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "经验",
            prop: "experience"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                style: {"width":"350px"},
                modelValue: _ctx.form.experience,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.experience = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "师傅照片",
            prop: "img"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_upload, {
                class: "store-uploader",
                action: "https://jsonplaceholder.typicode.com/posts/",
                "show-file-list": false,
                "before-upload": _ctx.beforeAvatarUpload,
                "on-change": 
                            (file, fileList) => {
                                _ctx.handleChange(file, false);
                            }
                        
              }, {
                tip: _withId(() => [
                  _hoisted_5
                ]),
                default: _withId(() => [
                  (_ctx.img.key)
                    ? (_openBlock(), _createBlock("div", _hoisted_2, [
                        _withDirectives(_createVNode("img", {
                          src: _ctx.img.url,
                          class: "store img media__image",
                          onLoad: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.imgLoad && _ctx.imgLoad(...args)))
                        }, null, 40, ["src"]), [
                          [_directive_loading, _ctx.imgLoading]
                        ]),
                        _hoisted_3
                      ]))
                    : (_openBlock(), _createBlock("i", _hoisted_4))
                ]),
                _: 1
              }, 8, ["before-upload", "on-change"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"]), [
        [_directive_loading, _ctx.formLoading]
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          class: "bg-red",
          onClick: _ctx.onSubmit
        }, {
          default: _withId(() => [
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$route.query.id ? "保存" : "确定"), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withId(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ])
  ]))
})